export type NavSection = 'jobs' | 'capture' | 'queue' | 'flagged';

/**
 * Which tab a path belongs to. Capture routes carry their job
 * (`/jobs/:jobId/capture/...`) and so sit under the job's own path, which a
 * prefix match would light as Jobs. A job view and a capture result both
 * belong to Jobs, which is where the operator reached them from.
 */
export function activeSection(pathname: string): NavSection | null {
  if (pathname === '/capture' || /^\/jobs\/[^/]+\/capture(\/|$)/.test(pathname)) return 'capture';
  if (pathname === '/work' || pathname.startsWith('/jobs/') || /^\/capture\/[^/]+\/result$/.test(pathname)) {
    return 'jobs';
  }
  if (pathname.startsWith('/queue')) return 'queue';
  if (pathname.startsWith('/flagged')) return 'flagged';
  return null;
}

/**
 * Routes that take the whole phone screen: no header and no tab bar below
 * 64rem (plan/smart-capture/wireframes/mobile-fit.html, V-B). These are the
 * capture routes under a job, where the operator is holding the device up
 * to the item and every pixel goes to the preview or the decision in front
 * of them. Each draws its own Back to the job. From 64rem the rail stays,
 * because it costs width rather than height.
 */
export function isFullScreenRoute(pathname: string): boolean {
  return /^\/jobs\/[^/]+\/capture(\/|$)/.test(pathname);
}

/**
 * Task screens fill the viewport and carry their own pinned actions, so the
 * bottom tab bar is hidden on them and the shell is held to one screen
 * height (plan/portal-final/DECISIONS.md item 7). The extraction result is
 * one: its tabs scroll inside the screen and "Done, next item" stays on it.
 * The desktop rail stays, because it does not compete with the actions.
 */
export function isTaskRoute(pathname: string): boolean {
  return /^\/capture\/[^/]+\/result$/.test(pathname);
}
